import {
  FETCH_RETURNSGRID_DATA_BEGIN,
  FETCH_RETURNSGRID_DATA_SUCCESS,
  FETCH_RETURNSGRID_DATA_FAILURE,
  FETCH_PERFORMANCECALENDARYEARS_DATA_BEGIN,
  FETCH_PERFORMANCECALENDARYEARS_DATA_SUCCESS,
  FETCH_PERFORMANCECALENDARYEARS_DATA_FAILURE,
  FETCH_TRAILINGPERFORMANCE_DATA_BEGIN,
  FETCH_TRAILINGPERFORMANCE_DATA_SUCCESS,
  FETCH_TRAILINGPERFORMANCE_DATA_FAILURE,
  FETCH_VSBMCALYRS_DATA_BEGIN,
  FETCH_VSBMCALYRS_DATA_SUCCESS,
  FETCH_VSBMCALYRS_DATA_FAILURE,

  FETCH_STATSUMMARY_DATA_BEGIN,
  FETCH_STATSUMMARY_DATA_FAILURE,

  FETCH_BMSTATSUMMARYROR_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYSTDDEV_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYSHARPE_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYSORTINO_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYMAXDRAWDOWN_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYCORRELATION_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYBETA_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYALPHA_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYUPCAPTURE_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYDOWNCAPTURE_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYUPDOWNCAPTURE_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYALPHA_DATA_BEGIN,

  FETCH_BMSTATSUMMARY_DATA_FAILURE,
  FETCH_BMDDHistory_DATA_BEGIN,
  FETCH_BMDDHistory_DATA_SUCCESS,
  FETCH_BMDDHistory_DATA_FAILURE,
  FETCH_CUMMCHART_DATA_BEGIN,
  FETCH_CUMMCHART_DATA_SUCCESS,
  FETCH_CUMMCHART_DATA_FAILURE,
  FETCH_VAMICHART_DATA_BEGIN,
  FETCH_VAMICHART_DATA_SUCCESS,
  FETCH_VAMICHART_DATA_FAILURE,
  FETCH_ROLLINGCHART_DATA_BEGIN,
  FETCH_ROLLINGCHART_DATA_SUCCESS,
  FETCH_ROLLINGCHART_DATA_FAILURE,
  FETCH_DISTRCHART_DATA_BEGIN,
  FETCH_DISTRCHART_DATA_SUCCESS,
  FETCH_DISTRCHART_DATA_FAILURE,
  FETCH_STATSUMMARY_DATA_SUCCESS
    } from '../constants/returnsandstatistics';

const initialState={   
    isLoading:false,
    ReturnsGridData:{},
    PerformanceCalendarYearsData:{},
    TrailingPerformanceData:{},
    VsBMCalyrsData:{},
    BMDDHistoryData:{},
    BMStatSummaryRorData:{},
    BMStatSummaryStdDevData:{},
    BMStatSummarySharpeData:{},
    BMStatSummarySortinoData:{},
    BMStatSummaryMaxDrawdownData:{},
    BMStatSummaryCorrelationData:{},
    BMStatSummaryBetaData:{},
    BMStatSummaryAlphaData:{},
    BMStatSummaryUpCaptureData:{},
    BMStatSummaryDownCaptureData:{},
    BMStatSummaryUpDownCaptureData:{},
    cumulativeChartData:[],
    isCumChartLoading:false,
    cumChartLoadingError:null,
    vamiChartData:[],
    isVamiChartLoading:false,
    vamiChartLoadingError:null,
    rollingChartData:{},
    isRollingChartDataLoading:false,
    rollingChartLoadingError:null,
    DistChartData:{},
    isDistChartDataLoading:false,
    DistChartDataLoadingError:null,
    error:"",
    chartLoading:true
}
export const getReturnsAndStatisticsReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
     case FETCH_STATSUMMARY_DATA_SUCCESS:
 
         return {
             ...state,
             chartLoading: false,
         };
     case FETCH_STATSUMMARY_DATA_BEGIN:
         return {
             ...state,
             chartLoading: true,
         };
    //Fetch Returns Grid
    case FETCH_RETURNSGRID_DATA_BEGIN: 
        return {
          ...state,
          isLoading: true,
          error: null,
        };
    case FETCH_RETURNSGRID_DATA_FAILURE:
        return {
            ...state,
            isLoading:true,
            error:payload.error,
            ReturnsGridData:[],
        };
    case FETCH_RETURNSGRID_DATA_SUCCESS:
        return {
            ...state,
            isLoading:false,
            ReturnsGridData:payload.ReturnsGridData,
        };
    //Fetch Performance Calendar Years
    case FETCH_PERFORMANCECALENDARYEARS_DATA_BEGIN: 
    return {
      ...state,
      isLoading: true,
      error: null,
      
    };
case FETCH_PERFORMANCECALENDARYEARS_DATA_FAILURE:
    return {
        ...state,
        isLoading:true,
        error: payload.error,
        PerformanceCalendarYearsData:[],
    };
case FETCH_PERFORMANCECALENDARYEARS_DATA_SUCCESS:
    return {
        ...state,
        isLoading:false,
        PerformanceCalendarYearsData:payload.PerformanceCalendarYearsData,
    };
     //Fetch Trailing Performance
     case FETCH_TRAILINGPERFORMANCE_DATA_BEGIN: 
     return {
       ...state,
       isLoading: true,
       error: null,
     };
 case FETCH_TRAILINGPERFORMANCE_DATA_FAILURE:
     return {
         ...state,
         isLoading:true,
         error: payload.error,
         TrailingPerformanceData:[],
     };
 case FETCH_TRAILINGPERFORMANCE_DATA_SUCCESS:
     return {
         ...state,
         isLoading:false,
         TrailingPerformanceData:payload.TrailingPerformanceData,
     };
      //Fetch Vs BM Cal Yrs
      case FETCH_VSBMCALYRS_DATA_BEGIN: 
      return {
        ...state,
        isLoading: true,
        error: null,
      };
  case FETCH_VSBMCALYRS_DATA_FAILURE:
      return {
          ...state,
          isLoading:true,
          error: payload.error,
          VsBMCalyrsData:[],
      };
  case FETCH_VSBMCALYRS_DATA_SUCCESS:
      return {
          ...state,
          isLoading:false,
          VsBMCalyrsData:payload.VsBMCalyrsData,
      };

      //Fetch Vs BM Cal Yrs
      case FETCH_STATSUMMARY_DATA_BEGIN: 
      return {
        ...state,
        isLoading: true,
        error: null,
      };
     case FETCH_STATSUMMARY_DATA_FAILURE:
         return {
             ...state,
             isLoading: true,
             error: payload.error,
             BMStatSummaryRorData: {},
             BMStatSummaryAlphaData: {},
             BMStatSummaryRorData: {},
             BMStatSummarySortinoData: {},
             BMStatSummaryStdDevData: {},
             BMStatSummarySharpeData: {},           
             BMStatSummaryCorrelationData: {},
             BMStatSummaryMaxDrawdownData: [],
             BMStatSummaryBetaData: {},
             BMStatSummaryUpCaptureData: [],
             BMStatSummaryDownCaptureData: {},
             BMStatSummaryUpDownCaptureData: {},
             
          };


  //Fetch BM Stat Summary
  case FETCH_BMSTATSUMMARYROR_DATA_SUCCESS:
      return {
          ...state,
          isLoading:false,
          BMStatSummaryRorData: payload.BMStatSummaryRorData,
      };
  case FETCH_BMSTATSUMMARYSTDDEV_DATA_SUCCESS:
    return {
        ...state,
        isLoading:false,
        BMStatSummaryStdDevData: payload.BMStatSummaryStdDevData,
    };
    case FETCH_BMSTATSUMMARYSHARPE_DATA_SUCCESS:
    return {
        ...state,
        isLoading:false,
        BMStatSummarySharpeData: payload.BMStatSummarySharpeData,
    };
    case FETCH_BMSTATSUMMARYSORTINO_DATA_SUCCESS:
    return {
        ...state,
        isLoading:false,
        BMStatSummarySortinoData: payload.BMStatSummarySortinoData,
    };
    case FETCH_BMSTATSUMMARYCORRELATION_DATA_SUCCESS:
        return {
            ...state,
            isLoading:false,
            BMStatSummaryCorrelationData: payload.BMStatSummaryCorrelationData,
        };
    case FETCH_BMSTATSUMMARYMAXDRAWDOWN_DATA_SUCCESS:
        return {
            ...state,
            isLoading:false,
            BMStatSummaryMaxDrawdownData: payload.BMStatSummaryMaxDrawdownData,
        };
    case FETCH_BMSTATSUMMARYBETA_DATA_SUCCESS:
        return {
            ...state,
            isLoading:false,
            BMStatSummaryBetaData: payload.BMStatSummaryBetaData,
        };
    case FETCH_BMSTATSUMMARYALPHA_DATA_SUCCESS:
        return {
            ...state,
            isLoading:false,
            BMStatSummaryAlphaData: payload.BMStatSummaryAlphaData,
        };
    case FETCH_BMSTATSUMMARYUPCAPTURE_DATA_SUCCESS:
        return {
            ...state,
            isLoading:false,
            BMStatSummaryUpCaptureData: payload.BMStatSummaryUpCaptureData,
        };
    case FETCH_BMSTATSUMMARYDOWNCAPTURE_DATA_SUCCESS:
        return {
            ...state,
            isLoading:false,
            BMStatSummaryDownCaptureData: payload.BMStatSummaryDownCaptureData,
        };
    case FETCH_BMSTATSUMMARYUPDOWNCAPTURE_DATA_SUCCESS:
        return {
            ...state,
            isLoading:false,
            BMStatSummaryUpDownCaptureData: payload.BMStatSummaryUpDownCaptureData,
        };
    case FETCH_BMSTATSUMMARY_DATA_FAILURE:
        return {
            ...state,
            isLoading:true,
            error:payload.error
         };

     //begin

     case FETCH_BMSTATSUMMARYALPHA_DATA_BEGIN:
         return {
             ...state,
             isLoading: true,
             error: null,
         };
       

  //Fetch BM Stat Summary
  case FETCH_BMDDHistory_DATA_BEGIN: 
  return {
        ...state,
        isLoading: true,
        error: null,
  };
  case FETCH_BMDDHistory_DATA_FAILURE:
      return {
          ...state,
          isLoading:true,
          error: payload.error,
          BMDDHistoryData:[],
      };
  case FETCH_BMDDHistory_DATA_SUCCESS:
      return {
          ...state,
          isLoading:false,
          BMDDHistoryData:payload.BMDDHistoryData,
      };
    case FETCH_CUMMCHART_DATA_BEGIN:
        return {
            ...state,
            isCumChartLoading:true,
        };
    case FETCH_CUMMCHART_DATA_SUCCESS:
         return {
             ...state,
             isCumChartLoading: false,
             cumulativeChartData:payload.chartData
         };
    case FETCH_CUMMCHART_DATA_FAILURE:
         return {
             ...state,
             isCumChartLoading: false,
             cumChartLoadingError:[],
         };
    
    case FETCH_VAMICHART_DATA_BEGIN:
         return {
             ...state,
             isVamiChartLoading: true,
         };
    case FETCH_VAMICHART_DATA_SUCCESS:
         return {
             ...state,
             isVamiChartLoading: false,
             vamiChartData: payload.chartData
         };
    case FETCH_VAMICHART_DATA_FAILURE:
        return {
        ...state,
        isVamiChartLoading: false,
        vamiChartData: [],
    };
    
     case FETCH_ROLLINGCHART_DATA_BEGIN:
         return {
             ...state,
             isRollingChartDataLoading: true,
         };
     case FETCH_ROLLINGCHART_DATA_SUCCESS:
         return {
             ...state,
             isRollingChartDataLoading: false,
             rollingChartData: payload.chartData
         };
     case FETCH_ROLLINGCHART_DATA_FAILURE:
         return {
             ...state,
             isRollingChartDataLoading: false,
             rollingChartData: [],
         };
    
    
     case FETCH_DISTRCHART_DATA_BEGIN:
         return {
             ...state,
             isDistChartDataLoading: true,
         };
     case FETCH_DISTRCHART_DATA_SUCCESS:
         return {
             ...state,
             isDistChartDataLoading: false,
             DistChartData: payload.chartData
         };
     case FETCH_DISTRCHART_DATA_FAILURE:
         return {
             ...state,
             isDistChartDataLoading: false,
             DistChartDataLoadingError: payload.error,
             DistChartData:[],
         };
    default:
        return state;
 }
}

export default getReturnsAndStatisticsReducer
